import React from "react";
import HeaderLeftMenu from "./HeaderLeftMenu/HeaderLeftMenu";
import HeaderRightMenu from "./HeaderRightMenu/HeaderRightMenu";
import HeaderCenterMenu from "./HeaderCenterMenu/HeaderCenterMenu";
import { useSelector, useDispatch } from "react-redux";

const Header = (props) => {
  const { setLoginHeader } = props
  const currentStep = useSelector((state) => state.paginationData.currentStep)
  return (
    <>
      <div className="header">
        <HeaderLeftMenu setLoginHeader={setLoginHeader} />
        <HeaderCenterMenu />
        <HeaderRightMenu />
       
      </div>
       {currentStep === 2 && <div className="custom-overlay-header"></div>}
       {currentStep === 3 && <div className="custom-overlay-header"></div>}
      {currentStep === 4 && <div className="custom-overlay-header"></div>}
      {currentStep === 5 && <div className="custom-overlay-header"></div>}
    </>
  );
};

export default Header;
